export type { IGamesGridColumns } from '../../common/components/GamesGrid';

const emoji1 = '/emoji/emoji1.webp';
const emoji2 = '/emoji/emoji2.webp';
const emoji3 = '/emoji/emoji3.webp';
const emoji4 = '/emoji/emoji4.webp';

export const emptyListImages = [emoji1, emoji2, emoji3, emoji4, emoji1];

export const PER_CHUNK_CONFIG = {
  desktopL: 63,
  desktop: 63,
  tablet: 24,
  mobile: 24,
  mobileS: 24,
};

/**
 * Games filter page size configuration for mobile and desktop
 */
export const GAMES_FILTER_PAGE_SIZE = {
  MOBILE: 24,
  DESKTOP: 63,
} as const;

/**
 * Games grid columns configuration
 */
export const GAMES_GRID_COLUMNS = {
  desktop: 7,
  mobile: 3,
} as const;

export const GRID_OPTIONS = {
  columns: 7,
  columnsTablet: 4,
  columnsMobile: 3,
  columnsMobileS: 3,
  columnGap: 16,
  rowGap: 16,
};

export const TOURNAMENT_PER_CHUNK_CONFIG = {
  desktopL: 14,
  desktop: 14,
  tablet: 6,
  mobile: 6,
  mobileS: 6,
};
